import React from 'react';
import Drawer from "@mui/material/Drawer";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material";
export const CustomDrawer = ({ anchorDirection, isOpen, children, rootStyle, paperStyle, listStyle, footer, footerStyle, onCloseCallBack, title, titleStyle, dialogContentStyle, variant, dataQa = 'custom-drawer', }) => {
    const StyledDrawer = styled(Drawer)({
        '.MuiDrawer-root': rootStyle,
        '.MuiDrawer-paper': paperStyle,
    });
    return (React.createElement(StyledDrawer, { variant: variant, anchor: anchorDirection, open: isOpen, onClose: onCloseCallBack, "data-qa": dataQa },
        title && React.createElement(DialogTitle, { sx: titleStyle }, title),
        React.createElement(DialogContent, { sx: dialogContentStyle, dividers: true },
            React.createElement(DialogContentText, { sx: listStyle, id: "scroll-dialog-description", tabIndex: -1, component: 'div' }, children)),
        footer && React.createElement(DialogActions, { sx: footerStyle }, footer)));
};
